<template>
  <div>
    <a-card title="追溯信息管理">
      <!-- 工具栏 -->
      <div style="display:flex; justify-content:flex-end; margin-bottom:14px">
        <a-button type="primary" icon="plus" @click="openFormulaModal">新增追溯信息</a-button>
      </div>

      <div style="display:flex; gap:12px; height:calc(100vh - 220px)">

        <!-- 产品侧边栏 -->
        <div class="sidebar" @scroll="onScroll">
          <div class="sidebar-title">产品列表</div>
          <div class="sidebar-search">
            <a-input-search
              placeholder="id或名称"
              allowClear
              @search="onSearch"
            />
          </div>
          <ul class="sidebar-list" v-if="productList.length > 0">
            <li
              v-for="(val, index) in productList"
              :key="val.id"
              class="sidebar-item"
              :class="{ active: index === productIndex }"
              @click="getBatchList(val.goods ? val.goods.id : val.id, index)"
            >
              {{ (val.goods && val.goods.name) || val.product_name }}
              <span style="color:#bfbfbf;font-size:11px">
                ({{ val.goods ? val.goods.id : val.id }})
              </span>
            </li>
          </ul>
          <!-- 空状态 -->
          <div v-else class="sidebar-empty">
            <a-icon type="search" style="font-size:28px;color:#d9d9d9;margin-bottom:8px;display:block" />
            <div>未找到匹配产品</div>
          </div>
        </div>

        <!-- 批次列表中间栏 -->
        <div class="batch-side">
          <div class="batch-side-title">批次列表</div>
          <div class="batch-side-search">
            <a-input-search
              placeholder="批次号"
              allowClear
              @search="onSearch1"
            />
          </div>
          <div v-if="loadingPici" style="text-align:center;padding:24px">
            <a-spin size="small" />
          </div>
          <ul class="batch-side-list" v-else>
            <li
              class="batch-side-item"
              :class="{ active: showAllBatches }"
              @click="showAll"
            >
              全部批次
              <span style="color:#bfbfbf;font-size:11px">({{ pagination.total }})</span>
            </li>
            <li
              v-for="(pici, pi) in filteredBatchList"
              :key="pici.batch"
              class="batch-side-item"
              :class="{ active: !showAllBatches && batchIndex === pi }"
              @click="getResultList(nowId, pi, pici)"
            >
              {{ pici.batch }}
              <span style="color:#bfbfbf;font-size:11px" v-if="pici.number && pici.number.length">
                ({{ pici.number.length }})
              </span>
            </li>
            <li v-if="filteredBatchList.length === 0" class="batch-side-empty">无匹配批次</li>
          </ul>
        </div>

        <!-- 批次卡片列表 -->
        <div class="batch-main" ref="batchMain">
          <div v-if="loading" style="text-align:center;padding:40px">
            <a-spin />
          </div>
          <template v-else>
            <div style="font-size:12px;color:#8c8c8c;margin-bottom:8px">
              共 {{ pagination.total }} 条批次记录，点击卡片查看完整详情
            </div>

            <div
              v-for="item in items"
              :key="item.id"
              :ref="'card-' + item.id"
              class="batch-card"
              :class="{ highlight: highlightId === item.id }"
              @click="openDetail(item)"
            >
              <!-- 卡片头部 -->
              <div class="batch-header">
                <div class="batch-left">
                  <div style="display:flex;align-items:center;gap:8px">
                    <span class="batch-no">{{ item.batch }}</span>
                    <a-tag :color="getCheckStatus(item).color">
                      {{ getCheckStatus(item).text }}
                    </a-tag>
                  </div>
                  <div class="batch-meta">
                    <span><strong>编号</strong> {{ item.number }}</span>
                    <span><strong>记录人</strong> {{ item.recorder }}</span>
                    <span v-if="item.reviewer"><strong>复核人</strong> {{ item.reviewer }}</span>
                    <span><strong>混合均匀</strong> {{ item.situation }}</span>
                    <span v-if="item.remark"><strong>备注</strong> {{ item.remark }}</span>
                  </div>
                </div>
                <div class="batch-actions" @click.stop>
                  <a-button-group>
                    <a-button icon="branches" size="small" @click="goTraceChain(item)">链路查询</a-button>
                    <a-button icon="edit" size="small" @click="openFormulaEditModal(item)">编辑</a-button>
                    <a-popconfirm title="确定删除吗" @confirm="destroyFormula(item.id)">
                      <a-button type="danger" icon="delete" size="small">删除</a-button>
                    </a-popconfirm>
                  </a-button-group>
                </div>
              </div>

              <!-- 优化③：原材料摘要行 -->
              <div class="material-summary" v-if="item.material && item.material.length">
                <span class="material-summary-label">原料：</span>
                <a-tag
                  v-for="(m, mi) in getMaterialSummary(item)"
                  :key="mi"
                  :color="m.state !== '正常' ? 'orange' : ''"
                  style="margin:1px 2px;font-size:11px"
                >{{ m.product_name }} {{ m.weight }}</a-tag>
              </div>

              <!-- 检验报告摘要行 -->
              <div
                class="check-area"
                :class="{ 'no-report': traceabilityMap[item.id] === null }"
              >
                <span class="check-label" :style="traceabilityMap[item.id] ? 'color:#1890ff' : (traceabilityMap[item.id] === null ? 'color:#ff4d4f' : 'color:#bfbfbf')">
                  检验报告
                </span>
                <!-- 加载中（undefined）：不下结论，避免“暂无”闪烁 -->
                <template v-if="traceabilityMap[item.id] === undefined">
                  <a-spin size="small" style="margin-left:4px" />
                  <span style="font-size:12px;color:#bfbfbf;margin-left:6px">加载中…</span>
                </template>
                <!-- 有报告 -->
                <template v-else-if="traceabilityMap[item.id]">
                  <a-tag
                    v-for="(sec, si) in (traceabilityMap[item.id].data || [])"
                    :key="si"
                    :color="(sec.result && sec.result.length) ? 'green' : 'orange'"
                    style="font-size:11px"
                  >{{ sec.title }}</a-tag>
                  <span style="font-size:11px;color:#bfbfbf;margin-left:auto">
                    {{ traceabilityMap[item.id].create_at }}
                  </span>
                </template>
                <!-- 确认无报告（null） -->
                <template v-else>
                  <span style="font-size:12px;color:#ff4d4f">暂无检验报告，请及时添加</span>
                  <a-button
                    type="danger"
                    size="small"
                    ghost
                    style="margin-left:auto;font-size:11px"
                    @click.stop="openDetailForNewCheck(item)"
                  >＋ 新增检验报告</a-button>
                </template>
              </div>
            </div>

            <!-- 加载更多提示 -->
            <div
              v-if="items.length < pagination.total"
              class="load-more"
              @click="loadMoreBatches"
            >加载更多批次 ↓（共 {{ pagination.total }} 条，已显示 {{ items.length }} 条）</div>
            <div v-if="items.length === 0 && !loading" style="text-align:center;padding:40px;color:#bfbfbf">
              <a-empty description="暂无批次记录" />
            </div>
          </template>
        </div>
      </div>

      <!-- 右侧抽屉详情 -->
      <a-drawer
        :visible="drawerVisible"
        :width="720"
        :title="drawerTitle"
        placement="right"
        @close="drawerVisible = false"
      >
        <template v-if="drawerItem">
          <!-- 投料记录分组 -->
          <div class="detail-section">
            <div class="detail-section-header">
              <span class="detail-section-title">📦 投料记录</span>
              <a-button-group>
                <a-button icon="edit" size="small" @click="openFormulaEditModal(drawerItem)">编辑</a-button>
                <a-popconfirm title="确定删除吗" @confirm="destroyFormulaAndClose(drawerItem.id)">
                  <a-button type="danger" icon="delete" size="small">删除</a-button>
                </a-popconfirm>
              </a-button-group>
            </div>
            <a-descriptions :column="3" size="small" bordered style="margin-bottom:12px">
              <a-descriptions-item label="编号">{{ drawerItem.number }}</a-descriptions-item>
              <a-descriptions-item label="生产日期/批次">{{ drawerItem.batch }}</a-descriptions-item>
              <a-descriptions-item label="记录人">{{ drawerItem.recorder }}</a-descriptions-item>
              <a-descriptions-item label="复核人">{{ drawerItem.reviewer }}</a-descriptions-item>
              <a-descriptions-item label="混合均匀情况">{{ drawerItem.situation }}</a-descriptions-item>
              <a-descriptions-item label="备注" v-if="drawerItem.remark">{{ drawerItem.remark }}</a-descriptions-item>
              <a-descriptions-item label="原材料描述" :span="3" v-if="drawerItem.others && drawerItem.others.describe_y && drawerItem.others.describe_y.length">
                {{ (drawerItem.others.describe_y || []).join('、') }}
              </a-descriptions-item>
              <a-descriptions-item label="生产投料描述" :span="3" v-if="drawerItem.others && drawerItem.others.describe_s && drawerItem.others.describe_s.length">
                {{ (drawerItem.others.describe_s || []).join('、') }}
              </a-descriptions-item>
            </a-descriptions>

            <!-- 原料明细表 -->
            <div v-if="drawerMaterials.length" style="margin-bottom:12px">
              <div style="font-size:12px;color:#8c8c8c;margin-bottom:6px">原料明细</div>
              <a-table
                :columns="materialColumns"
                :dataSource="drawerMaterials"
                :pagination="false"
                size="small"
                :rowKey="record => record.$idx"
              >
                <template slot="state" slot-scope="val">
                  <a-tag :color="val === '正常' ? 'green' : 'orange'">{{ val }}</a-tag>
                </template>
              </a-table>
            </div>
          </div>

          <!-- 检验报告分组 -->
          <div class="detail-section" style="margin-top:16px">
            <div class="detail-section-header">
              <span class="detail-section-title">📋 检验报告</span>
              <template v-if="!drawerInlineEdit">
                <a-button-group v-if="traceabilityMap[drawerItem.id]">
                  <a-button icon="edit" size="small" @click="startDrawerEdit(drawerItem)">编辑检验报告</a-button>
                  <a-popconfirm title="确定删除此检验报告吗" @confirm="destroyTraceability(drawerItem.id)">
                    <a-button type="danger" icon="delete" size="small">删除</a-button>
                  </a-popconfirm>
                </a-button-group>
                <a-button v-else-if="traceabilityMap[drawerItem.id] === undefined" size="small" disabled>加载中…</a-button>
                <a-button v-else type="primary" size="small" icon="plus" @click="startDrawerEdit(drawerItem)">
                  新增检验报告
                </a-button>
              </template>
              <a-button-group v-else>
                <a-button type="primary" size="small" :loading="drawerSaving" @click="saveDrawerTraceability">保存</a-button>
                <a-button size="small" @click="drawerInlineEdit = null">取消</a-button>
              </a-button-group>
            </div>

            <!-- 查看态 -->
            <div v-if="traceabilityMap[drawerItem.id] && !drawerInlineEdit">
              <a-descriptions :column="3" size="small" style="margin-bottom:12px">
                <a-descriptions-item label="创建时间">{{ traceabilityMap[drawerItem.id].create_at }}</a-descriptions-item>
                <a-descriptions-item label="批次">{{ traceabilityMap[drawerItem.id].date }}</a-descriptions-item>
                <a-descriptions-item label="编号">{{ traceabilityMap[drawerItem.id].number }}</a-descriptions-item>
              </a-descriptions>
              <div
                v-for="(sec, idx) in (traceabilityMap[drawerItem.id].data || [])"
                :key="idx"
                style="border:1px solid #f0f0f0;border-radius:4px;padding:12px;margin-bottom:10px;background:#fafafa"
              >
                <div style="font-weight:600;color:#1890ff;margin-bottom:8px">{{ sec.title }}</div>
                <div style="margin-bottom:8px">
                  <a-tag v-for="(r, ri) in (sec.result || [])" :key="ri" color="green">{{ r }}</a-tag>
                  <span v-if="!sec.result || !sec.result.length" style="color:#bfbfbf;font-size:12px">无描述</span>
                </div>
                <!-- 图片缩略图 -->
                <div v-if="sec.image && sec.image.length" style="display:flex;gap:8px;flex-wrap:wrap">
                  <a-upload
                    disabled
                    list-type="picture-card"
                    :file-list="normalizeImageList(sec.image)"
                    name="file"
                  />
                </div>
                <div v-else style="font-size:11px;color:#d9d9d9">暂无图片</div>
              </div>
            </div>

            <!-- 编辑态 -->
            <div v-else-if="drawerInlineEdit">
              <div
                v-for="(section, idx) in drawerInlineEdit.sections"
                :key="idx"
                style="border:1px solid #e8e8e8;border-radius:4px;padding:12px;margin-bottom:10px"
              >
                <div style="font-weight:600;color:#1890ff;margin-bottom:8px">{{ section.title }}</div>
                <div style="display:flex;align-items:flex-start;margin-bottom:8px">
                  <span style="width:70px;flex-shrink:0;font-size:12px;color:#8c8c8c;padding-top:4px">检验描述</span>
                  <a-select mode="tags" v-model="section.result" style="flex:1">
                    <a-select-option v-for="opt in section.options" :key="opt" :value="opt">{{ opt }}</a-select-option>
                  </a-select>
                </div>
                <div style="display:flex;align-items:flex-start">
                  <span style="width:70px;flex-shrink:0;font-size:12px;color:#8c8c8c;padding-top:4px">上传图片</span>
                  <div style="flex:1">
                    <upload :ID_image="section.image" :count="3" @handleChange="val => section.image = val" />
                  </div>
                </div>
              </div>
            </div>

            <!-- 加载中（undefined）：不下结论，避免红框闪烁 -->
            <div v-else-if="traceabilityMap[drawerItem.id] === undefined && !drawerInlineEdit" style="text-align:center;padding:20px;color:#bfbfbf">
              <a-spin /> <span style="margin-left:8px">检验报告加载中…</span>
            </div>

            <!-- 无报告且非编辑态 -->
            <div v-else style="border:1px dashed #ffa39e;border-radius:6px;padding:20px;text-align:center;background:#fff1f0">
              <p style="color:#ff4d4f;margin-bottom:12px">该批次暂无检验报告，请点击"新增检验报告"</p>
            </div>
          </div>
        </template>
      </a-drawer>

      <!-- 投料记录新增/编辑弹窗 -->
      <formula-form-modal
        v-model="formulaVisible"
        :form="formulaTargetItem"
        :formList2="formulaFormList"
        @create="onFormulaCreate"
        @update="onFormulaUpdate"
      />
    </a-card>

    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import Upload from '@/components/Upload/index';
import { fromProductList, traceabilityList, traceabilityAdd, traceabilityDel, tracePici } from "@/api/from";
import { formulasList, formulasDel } from "@/api/produce";

const SECTIONS_TPL = [
  { title: '半成品检测', options: ['半成品检测合格'] },
  { title: '成品检测',   options: ['成品检测合格'] },
  { title: '成品出库',   options: ['成品出库检测合格'] },
];

export default {
  name: "FromResult",
  components: {
    Upload,
    FormulaFormModal: () => import("@/views/produce/formula/FormModal.vue"),
  },
  data() {
    return {
      nowId: '',
      nowPici: '',
      productList: [],
      productIndex: 0,
      batchIndex: 0,
      showAllBatches: true,   // 默认展示该产品全部批次；选中具体批次后为 false
      batchKeyword: '',
      BatchList: { pici: [] },
      pagination: { current: 1, total: 0, pageSize: 20 },
      searchForm: { product_id: "", batch: '', page: 1, page_size: 20 },
      loading: false,
      loadingPici: false,
      items: [],
      traceabilityMap: {},   // formulaId -> traceability（已加载）
      inlineEditMap: {},     // formulaId -> { sections, traceabilityId } 编辑态
      inlineSavingMap: {},   // formulaId -> bool
      expandedRowKeys: [],
      // 投料记录弹窗
      formulaVisible: false,
      formulaTargetItem: { others: {}, unit: null },
      formulaFormList: [],
      importLoading: false,
      page: 1,
      page_size: 100,
      productKw: '',
      productTotal: 0,
      loadingMoreProducts: false,
      drawerVisible: false,
      drawerItem: null,
      drawerInlineEdit: null,
      drawerSaving: false,
      highlightId: null,
      materialColumns: [
        { title: '状态', dataIndex: 'state', scopedSlots: { customRender: 'state' }, width: 70 },
        { title: '原料名称', dataIndex: 'product_name' },
        { title: '重量', dataIndex: 'weight' },
        { title: '批次', dataIndex: 'material_batch' },
      ],
    };
  },
  computed: {
    filteredBatchList() {
      const pici = (this.BatchList && this.BatchList.pici) || [];
      if (!this.batchKeyword) return pici;
      return pici.filter(b => b.batch && b.batch.indexOf(this.batchKeyword) !== -1);
    },
    drawerMaterials() {
      const item = this.drawerItem;
      if (!item) return [];
      let mat = item.material;
      if (typeof mat === 'string') {
        try { mat = JSON.parse(mat); } catch (e) { return []; }
      }
      if (!Array.isArray(mat)) return [];
      return mat.map((m, i) => ({ ...m, $idx: i }));
    },
    drawerTitle() {
      if (!this.drawerItem) return '批次详情';
      return `批次 ${this.drawerItem.batch || ''} · ${this.drawerItem.number || ''}`;
    },
  },
  async created() {
    // 处理路由参数：自动定位到指定商品
    const productId = this.$route.query.product_id;
    const batch = this.$route.query.batch || '';
    if (productId) {
      await this.getRefreshWithoutAutoSelect();
      this.autoSelectProduct(parseInt(productId), batch);
    } else {
      await this.getRefresh();
    }
  },
  methods: {
    // ===== 产品列表 =====
    async getRefresh() {
      this.page = 1;
      const params = { page: 1, page_size: this.page_size };
      if (this.productKw) params.product_kw = this.productKw;
      let res = await fromProductList(params);
      this.productList = (res.data || []).filter(item => item.goods);
      this.productTotal = res.count || 0;
      if (this.productList.length === 0) return;
      this.nowId = this.productList[0].goods.id;
      this.getBatchList(this.productList[0].goods.id, 0);
    },
    // 只加载产品列表，不自动选中（用于路由参数跳转）
    async getRefreshWithoutAutoSelect() {
      this.page = 1;
      const params = { page: 1, page_size: this.page_size };
      if (this.productKw) params.product_kw = this.productKw;
      let res = await fromProductList(params);
      this.productList = (res.data || []).filter(item => item.goods);
      this.productTotal = res.count || 0;
    },
    // 根据 product_id 自动选中商品
    autoSelectProduct(productId, batch = '') {
      const index = this.productList.findIndex(item => item.goods && item.goods.id === productId);
      if (index !== -1) {
        // 找到了，直接选中
        this.getBatchList(this.productList[index].goods.id, index, batch);
      } else {
        // 没找到，可能需要搜索加载
        this.$message.info('正在定位到指定商品...');
        fromProductList({ product_kw: productId.toString(), page: 1, page_size: this.page_size })
          .then(res => {
            const list = (res.data || []).filter(item => item.goods);
            const targetIndex = list.findIndex(item => item.goods.id === productId);
            if (targetIndex !== -1) {
              this.productList = list;
              this.productTotal = res.count || 0;
              this.page = 1;
              this.getBatchList(list[targetIndex].goods.id, targetIndex, batch);
            } else {
              this.$message.warning('未找到该商品的追溯信息');
            }
          })
          .catch(() => {
            this.$message.error('定位商品失败');
          });
      }
    },
    async getProductList() {
      const params = { page: this.page, page_size: this.page_size };
      if (this.productKw) params.product_kw = this.productKw;
      let res = await fromProductList(params);
      this.productList = [...this.productList, ...(res.data || []).filter(item => item.goods)];
      this.productTotal = res.count || this.productTotal;
    },
    onScroll(e) {
      const bottomDistance = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
      if (bottomDistance < 50 && this.productList.length < this.productTotal && !this.loadingMoreProducts) {
        this.loadingMoreProducts = true;
        this.page++;
        this.getProductList().finally(() => { this.loadingMoreProducts = false; });
      }
    },
    onSearch(val) {
      this.productIndex = null;
      this.productKw = val || '';
      this.getProductInfo(val);
    },
    async getProductInfo(val) {
      let res = await fromProductList({ product_kw: val || '', page: 1, page_size: this.page_size });
      this.productList = (res.data || []).filter(item => item.goods);
      this.productTotal = res.count || 0;
      this.page = 1;
      if (this.productList.length > 0) {
        this.productIndex = 0;
        const firstGoodsId = this.productList[0].goods.id;
        this.nowId = firstGoodsId;
        this.getBatchList(firstGoodsId, 0);
      } else {
        this.nowId = '';
        this.BatchList = { pici: [] };
        this.nowPici = '';
        this.items = [];
        this.pagination.total = 0;
      }
    },

    // ===== 批次列表 =====
    onSearch1(val) {
      this.batchKeyword = val || '';
      this.batchIndex = null;
    },
    getBatchList(val, num, targetBatch = '') {
      this.productIndex = num;
      this.batchListInfo(val, targetBatch);
    },
    async batchListInfo(id, targetBatch = '') {
      this.loadingPici = true;
      try {
        let res1 = await tracePici({ product_id: id });
        this.BatchList = res1.data || { pici: [] };
        this.nowId = id;
        const pici = this.BatchList.pici || [];
        if (targetBatch) {
          const targetIndex = pici.findIndex(item => item.batch === targetBatch);
          if (targetIndex !== -1) {
            this.batchIndex = targetIndex;
            this.nowPici = targetBatch;
            this.showAllBatches = false;
            this.batchKeyword = '';
            this.searchForm.page = 1;
            this.pagination.current = 1;
            this.list(id, targetBatch);
            return;
          }
        }
        // nowPici 仅作为"新增投料记录"时预填批次的默认值，不再用于过滤卡片列表
        if (pici.length > 0) {
          this.batchIndex = 0;
          this.nowPici = pici[0].batch;
        } else {
          this.batchIndex = 0;
          this.nowPici = '';
        }
        // 切换产品默认展示全部批次
        this.showAllBatches = true;
        this.batchKeyword = '';
        this.searchForm.page = 1;
        this.pagination.current = 1;
        this.list(id, '');
      } finally {
        this.loadingPici = false;
      }
    },
    getResultList(id, num, pici) {
      this.showAllBatches = false;
      this.batchIndex = num;
      this.nowId = id;
      this.nowPici = pici.batch;
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list(id, pici.batch);
    },
    // 回到"全部批次"总览
    showAll() {
      this.showAllBatches = true;
      this.batchIndex = 0;
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list(this.nowId, '');
    },

    // ===== 投料记录列表 =====
    list(id, batch) {
      this.searchForm.product_id = id;
      this.searchForm.batch = batch;
      this.loading = true;
      this.expandedRowKeys = [];
      this.traceabilityMap = {};
      this.inlineEditMap = {};
      this.inlineSavingMap = {};
      formulasList({ ...this.searchForm, product_id: id, batch: batch || undefined })
        .then((data) => {
          this.pagination.total = data.count;
          this.items = data.data || [];
          // 批量预加载本批次检验报告，卡片状态才能正确显示
          this.loadBatchReports(this.items, batch);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableChange(pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.searchForm.page_size = pagination.pageSize;
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      if (sorter && sorter.field && sorter.order) {
        this.searchForm.ordering = `${sorter.order === "descend" ? "-" : ""}${sorter.field}`;
      } else {
        delete this.searchForm.ordering;
      }
      this.list(this.nowId, '');
    },

    // ===== 聚合：把同一批次返回的平铺行（每行一个 title）按 number 聚合成报告对象 =====
    // 后端 QTraceabilityView2 每个检测环节返回一行 {id,title,result,image,number,date}，
    // 一份报告 = 同一 number 下的多行；这里按 SECTIONS_TPL 顺序组装成 { data:[...], ids:[...] }
    buildReportMap(rows) {
      const parseJSON = (v, fallback) => {
        if (typeof v === 'string') {
          try { return JSON.parse(v); } catch (e) { return fallback; }
        }
        return v == null ? fallback : v;
      };
      const byNumber = {};
      (rows || []).forEach((row) => {
        const num = row.number;
        if (!byNumber[num]) {
          byNumber[num] = {
            id: row.id,            // 兼容旧引用：用首行 id
            number: num,
            date: row.date,
            create_at: row.create_at,
            ids: [],
            data: [],
          };
        }
        byNumber[num].ids.push(row.id);
        byNumber[num].data.push({
          id: row.id,
          title: row.title,
          result: parseJSON(row.result, []),
          image: parseJSON(row.image, []),
        });
      });
      // 每份报告内部按 SECTIONS_TPL 顺序排序，保证模板/编辑态索引对齐
      const order = SECTIONS_TPL.map(s => s.title);
      Object.values(byNumber).forEach((rep) => {
        rep.data.sort((a, b) => order.indexOf(a.title) - order.indexOf(b.title));
      });
      return byNumber;
    },

    // ===== 加载报告，按 number 聚合后写入 traceabilityMap（key=formula.id）=====
    // items 可能跨多个批次（全批次展示），按各自 item.batch 分组，每个批次查一次
    async loadBatchReports(items, batch) {
      const list = items || [];
      if (!this.nowId || list.length === 0) {
        list.forEach(it => this.$set(this.traceabilityMap, it.id, null));
        return;
      }
      // 按 batch 分组：优先用入参 batch（单批次场景，如 onExpand），否则按各行 item.batch
      const groups = {};
      list.forEach((it) => {
        const b = batch || it.batch || '';
        if (!groups[b]) groups[b] = [];
        groups[b].push(it);
      });
      await Promise.all(Object.keys(groups).map(async (b) => {
        const groupItems = groups[b];
        if (!b) {
          groupItems.forEach(it => this.$set(this.traceabilityMap, it.id, null));
          return;
        }
        try {
          const res = await traceabilityList({
            product_id: this.nowId,
            pici: b,
            page: 1,
            page_size: 999,
          });
          const reportByNumber = this.buildReportMap(res.data || []);
          groupItems.forEach((it) => {
            this.$set(this.traceabilityMap, it.id, reportByNumber[it.number] || null);
          });
        } catch (e) {
          groupItems.forEach(it => this.$set(this.traceabilityMap, it.id, null));
        }
      }));
    },

    // ===== 展开行/抽屉：确保该投料记录的检验报告已加载 =====
    async onExpand(expanded, record) {
      if (!expanded) {
        this.expandedRowKeys = this.expandedRowKeys.filter(k => k !== record.id);
        return;
      }
      this.expandedRowKeys = [...this.expandedRowKeys, record.id];
      if (this.traceabilityMap[record.id] !== undefined) return;
      await this.loadBatchReports([record], record.batch);
    },

    // ===== 内联编辑：进入编辑态 =====
    startInlineEdit(formulaItem) {
      const existing = this.traceabilityMap[formulaItem.id];
      // 基于已有数据或默认值构建三段表单
      const sections = SECTIONS_TPL.map((tpl, idx) => {
        const existingSection = existing && existing.data && existing.data[idx];
        const result = (existingSection && existingSection.result) || [tpl.options[0]];
        const rawImages = (existingSection && existingSection.image) || [];
        const image = rawImages.map((img, i) => {
          if (typeof img === 'string') {
            const n = img.split('/');
            return { uid: String(i), name: n[n.length - 1], status: 'done', url: img };
          }
          return img;
        });
        return { title: tpl.title, options: tpl.options, result, image };
      });
      this.$set(this.inlineEditMap, formulaItem.id, {
        hasReport: !!existing,
        sections,
      });
    },

    // ===== 抽屉内进入编辑态：构建编辑数据并打通 drawerInlineEdit =====
    // startInlineEdit 只写 inlineEditMap，抽屉视图靠 drawerInlineEdit 判断显隐，
    // 两者必须同时设置，否则点击按钮后界面无任何变化（表现为“点击无响应”）。
    startDrawerEdit(formulaItem) {
      this.startInlineEdit(formulaItem);
      this.drawerInlineEdit = this.inlineEditMap[formulaItem.id];
    },

    // ===== 内联编辑：取消 =====
    cancelInlineEdit(formulaId) {
      this.$set(this.inlineEditMap, formulaId, null);
    },

    // ===== 内联编辑：保存 =====
    async saveInlineTraceability(formulaItem) {
      const editState = this.inlineEditMap[formulaItem.id];
      if (!editState) return;
      this.$set(this.inlineSavingMap, formulaItem.id, true);

      const toUrls = (fileList) => (fileList || [])
        .filter(f => f.status === 'done')
        .map(f => f.url || (f.response && f.response.data && f.response.data.file_url));

      const data = editState.sections.map(s => ({
        title: s.title,
        result: s.result,
        image: toUrls(s.image),
      }));

      // 一份报告 = 3 个检测环节（3 行）。后端 ATraceabilityView2 按
      // product_id+number+date+title 做 upsert，新增/修改统一走它，整份一起写。
      const payload = {
        product_id: this.nowId,
        date: formulaItem.batch,
        number: formulaItem.number,
        data,
      };
      const wasReport = editState.hasReport;
      try {
        const res = await traceabilityAdd(payload);
        if (res.code === 200) {
          this.$message.success(wasReport ? '修改成功' : '新增成功');
          // 清编辑态，重新加载该行检验报告
          this.$set(this.inlineEditMap, formulaItem.id, null);
          this.$set(this.traceabilityMap, formulaItem.id, undefined);
          // 触发重新加载（onExpand 只在 undefined 时发请求）
          const fakeRecord = { id: formulaItem.id, batch: formulaItem.batch, number: formulaItem.number };
          await this.onExpand(true, fakeRecord);
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (e) {
        this.$message.error('保存失败');
      } finally {
        this.$set(this.inlineSavingMap, formulaItem.id, false);
      }
    },

    // ===== 删除检验报告（一份报告含多行，逐行删除）=====
    async destroyTraceability(formulaId) {
      const t = this.traceabilityMap[formulaId];
      if (!t) return;
      const ids = (t.ids && t.ids.length) ? t.ids : (t.id ? [t.id] : []);
      try {
        await Promise.all(ids.map(id => traceabilityDel({ id })));
        this.$message.success('删除成功');
        this.$set(this.traceabilityMap, formulaId, null);
      } catch (e) {
        this.$message.error('删除失败');
      }
    },

    // ===== 图片列表规范化（查看态） =====
    normalizeImageList(images) {
      if (!Array.isArray(images)) return [];
      return images.map((img, i) => {
        if (typeof img === 'string') {
          const n = img.split('/');
          return { uid: String(i), name: n[n.length - 1], status: 'done', url: img };
        }
        return img;
      });
    },

    // ===== 检验状态(已验证) =====
    getMaterialSummary(item) {
      let mat = item.material;
      if (typeof mat === 'string') {
        try { mat = JSON.parse(mat); } catch (e) { return []; }
      }
      if (!Array.isArray(mat)) return [];
      return mat.slice(0, 5);
    },
    openDetailForNewCheck(item) {
      this.openDetail(item);
      // 打开后自动进入新增检验报告编辑态（等 traceabilityMap 加载完再触发）
      const tryEnterEdit = (retries) => {
        if (this.traceabilityMap[item.id] !== undefined) {
          if (!this.traceabilityMap[item.id]) {
            this.startDrawerEdit(item);
          }
          return;
        }
        if (retries > 0) setTimeout(() => tryEnterEdit(retries - 1), 300);
      };
      setTimeout(() => tryEnterEdit(10), 300);
    },
    getCheckStatus(item) {
      const t = this.traceabilityMap[item.id];
      if (t === undefined) return { color: 'default', text: '加载中' };
      if (!t) return { color: 'red', text: '无报告' };
      return { color: 'green', text: '已检验' };
    },

    // ===== 加载更多批次 =====
    loadMoreBatches() {
      this.searchForm.page += 1;
      this.pagination.current = this.searchForm.page;
      const batch = this.showAllBatches ? '' : this.nowPici;
      this.loading = true;
      formulasList({ ...this.searchForm, product_id: this.nowId, batch: batch || undefined })
        .then((data) => {
          this.pagination.total = data.count;
          const newItems = data.data || [];
          this.items = [...this.items, ...newItems];
          // 新追加的批次也要预加载检验报告（按各自 batch）
          this.loadBatchReports(newItems, batch);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ===== Drawer 详情 =====
    goTraceChain(item) {
      const query = {}
      if (this.nowId) query.goods_id = String(this.nowId)
      if (item && item.batch) query.batch = item.batch
      this.$router.push({ path: '/from/trace_chain', query })
    },
    openDetail(item) {
      this.drawerItem = item;
      this.drawerInlineEdit = null;
      this.drawerVisible = true;
      if (this.traceabilityMap[item.id] === undefined) {
        this.onExpand(true, item);
      }
    },
    async saveDrawerTraceability() {
      await this.saveInlineTraceability(this.drawerItem);
      // saveInlineTraceability 成功后会清空 inlineEditMap，同步清 drawerInlineEdit
      if (!this.inlineEditMap[this.drawerItem.id]) {
        this.drawerInlineEdit = null;
      }
    },

    // ===== 投料记录操作 =====
    openFormulaModal() {
      const cloned = { others: { describe_y: [], describe_s: [] }, unit: null };
      if (this.nowId) cloned.product_id = Number(this.nowId);
      if (this.nowPici) cloned.batch = this.nowPici;
      if (!cloned.number) cloned.number = 'zcac';
      this.formulaFormList = [{ state: '正常', product_name: '', weight: '', material_batch: '', report_img: [] }];
      this.formulaTargetItem = cloned;
      this.formulaVisible = true;
    },
    openFormulaEditModal(item) {
      const cloned = JSON.parse(JSON.stringify(item));
      if (typeof cloned.others === 'string') {
        try { cloned.others = JSON.parse(cloned.others); } catch (e) { cloned.others = {}; }
      }
      if (!cloned.others || typeof cloned.others !== 'object') cloned.others = {};
      if (!cloned.others.describe_y) cloned.others.describe_y = [];
      if (!cloned.others.describe_s) cloned.others.describe_s = [];
      const material = cloned.material;
      if (!material || (Array.isArray(material) && material.length === 0)) {
        this.formulaFormList = [{ state: '正常', product_name: '', weight: '', material_batch: '', report_img: [] }];
      } else {
        this.formulaFormList = [];
      }
      this.formulaTargetItem = cloned;
      this.formulaVisible = true;
    },
    async destroyFormula(id) {
      try {
        await formulasDel({ id });
        this.$message.success('删除成功');
        await this.refreshBatch();
        this.list(this.nowId, this.showAllBatches ? '' : this.nowPici);
      } catch (e) {
        this.$message.error('删除失败');
      }
    },
    async destroyFormulaAndClose(id) {
      await this.destroyFormula(id);
      this.drawerVisible = false;
    },

    // ===== 回调刷新 =====
    async onFormulaCreate() {
      await this.refreshCurrentProduct(); // 刷新当前产品信息（可能在其他地方被修改了名称）
      await this.refreshBatch();
      this.list(this.nowId, this.showAllBatches ? '' : this.nowPici);
    },
    async onFormulaUpdate() {
      await this.refreshCurrentProduct(); // 刷新当前产品信息
      this.list(this.nowId, this.showAllBatches ? '' : this.nowPici);
    },
    async refreshCurrentProduct() {
      // 刷新左侧产品列表中当前选中产品的信息（确保显示最新的产品名称）
      if (!this.nowId || this.productIndex < 0) return;
      try {
        const res = await fromProductList({ product_kw: this.nowId.toString(), page: 1, page_size: 10 });
        if (res.data && res.data.length > 0) {
          // 查找匹配当前产品ID的记录
          const matchedProduct = res.data.find(item => {
            const itemId = item.goods ? item.goods.id : item.id;
            return itemId == this.nowId;
          });

          if (matchedProduct) {
            // 更新产品列表中的当前项
            this.$set(this.productList, this.productIndex, matchedProduct);
            console.log('产品信息已刷新:', matchedProduct);
          } else {
            console.warn('未找到匹配的产品ID:', this.nowId);
          }
        }
      } catch (e) {
        console.error('刷新产品信息失败', e);
      }
    },
    async refreshBatch() {
      if (!this.nowId) return;
      this.loadingPici = true;
      try {
        const res = await tracePici({ product_id: this.nowId });
        this.BatchList = res.data || { pici: [] };
        const pici = this.BatchList.pici || [];
        if (this.nowPici && pici.some(b => b.batch === this.nowPici)) return;
        if (pici.length > 0) {
          this.nowPici = pici[0].batch;
          this.batchIndex = 0;
        } else {
          this.nowPici = '';
          this.batchIndex = 0;
        }
      } finally {
        this.loadingPici = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* ===== 产品侧边栏 ===== */
.sidebar {
  width: 200px;
  flex-shrink: 0;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow-y: auto;
  background: #fff;
}
.sidebar-title {
  font-weight: 600;
  padding: 10px 12px 6px;
  font-size: 13px;
  color: #262626;
  border-bottom: 1px solid #f0f0f0;
}
.sidebar-search {
  padding: 8px;
}
.sidebar-list {
  padding: 4px 0;
}
.sidebar-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.4;
  border-left: 3px solid transparent;
  transition: background 0.15s;
  &:hover {
    background: #f5f5f5;
  }
  &.active {
    background: #e6f7ff;
    border-left-color: #1890ff;
    color: #1890ff;
  }
}
.sidebar-empty {
  padding: 24px 12px;
  text-align: center;
  color: #bfbfbf;
  font-size: 12px;
}

/* ===== 批次列表中间栏 ===== */
.batch-side {
  width: 180px;
  flex-shrink: 0;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow-y: auto;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.batch-side-title {
  font-weight: 600;
  padding: 10px 12px 6px;
  font-size: 13px;
  color: #262626;
  border-bottom: 1px solid #f0f0f0;
}
.batch-side-search {
  padding: 8px;
}
.batch-side-list {
  padding: 4px 0;
  overflow-y: auto;
}
.batch-side-item {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.4;
  border-left: 3px solid transparent;
  transition: background 0.15s;
  &:hover {
    background: #f5f5f5;
  }
  &.active {
    background: #e6f7ff;
    border-left-color: #1890ff;
    color: #1890ff;
  }
}
.batch-side-empty {
  padding: 16px 12px;
  text-align: center;
  color: #bfbfbf;
  font-size: 12px;
}

/* ===== 批次主区域 ===== */
.batch-main {
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
}

/* ===== 批次卡片 ===== */
.batch-card {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
  background: #fff;
  cursor: pointer;
  transition: box-shadow 0.2s, border-color 0.2s;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-color: #1890ff;
  }
  &.highlight {
    border-color: #faad14;
    box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
  }
}
.batch-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}
.batch-left {
  flex: 1;
}
.batch-no {
  font-weight: 600;
  font-size: 14px;
  color: #262626;
}
.batch-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.batch-actions {
  flex-shrink: 0;
  margin-left: 12px;
}
.material-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 6px;
  font-size: 12px;
}
.material-summary-label {
  color: #8c8c8c;
  flex-shrink: 0;
}
.check-area {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: #f6ffed;
  border-radius: 4px;
  border: 1px solid #b7eb8f;
  flex-wrap: wrap;
  &.no-report {
    background: #fff2f0;
    border-color: #ffa39e;
  }
}
.check-label {
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}
.load-more {
  text-align: center;
  padding: 10px;
  color: #1890ff;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

/* ===== Drawer 详情分组 ===== */
.detail-section {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 14px;
}
.detail-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.detail-section-title {
  font-weight: 600;
  font-size: 14px;
  color: #262626;
}
</style>
